import { Product, ProductPricingPlan } from "@/Contracts/Products";

export const mergePricingImagesIntoProduct = <
	T extends Pick<Product, "item_images" | "pricing">
>(
	product: T
): T => {
	if (!product.pricing || product.pricing.length === 0) {
		return product;
	}

	const allPricingImages = product.pricing
		.flatMap((p: ProductPricingPlan) => p.images || [])
		.filter(
			(img: string, index: number, arr: string[]) =>
				arr.indexOf(img) === index
		);

	if (allPricingImages.length === 0) {
		return product;
	}

	const existingItemImages = product.item_images || [];
	const newImages = allPricingImages.filter(
		(img: string) => !existingItemImages.includes(img)
	);

	if (newImages.length === 0) {
		return product;
	}

	return {
		...product,
		item_images: [...newImages, ...existingItemImages]
	};
};
